/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Payload to update a client organization
 * @export
 * @interface UpdateClient
 */
export interface UpdateClient {
    /**
     * 
     * @type {string}
     * @memberof UpdateClient
     */
    internalName: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UpdateClient
     */
    metadataSchemaRID?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateClient
     */
    metadata?: object;
    /**
     * An optional unique identifier for the entity that may be provided from an external system
     * @type {string}
     * @memberof UpdateClient
     */
    uniqueIdentifier?: string;
}

/**
 * Check if a given object implements the UpdateClient interface.
 */
export function instanceOfUpdateClient(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalName" in value;

    return isInstance;
}

export function UpdateClientFromJSON(json: any): UpdateClient {
    return UpdateClientFromJSONTyped(json, false);
}

export function UpdateClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'internalName': json['internalName'],
        'metadataSchemaRID': !exists(json, 'metadataSchemaRID') ? undefined : json['metadataSchemaRID'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'uniqueIdentifier': !exists(json, 'uniqueIdentifier') ? undefined : json['uniqueIdentifier'],
    };
}

export function UpdateClientToJSON(value?: UpdateClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internalName': value.internalName,
        'metadataSchemaRID': value.metadataSchemaRID,
        'metadata': value.metadata,
        'uniqueIdentifier': value.uniqueIdentifier,
    };
}

